export const Emotes = {
  IDLE: 'asset://mp-idle.glb',
  WALK: 'asset://mp-walk.glb?s=1.5',
  WALK_LEFT: 'asset://mp-walk-left.glb?s=1.5',
  WALK_RIGHT: 'asset://mp-walk-right.glb?s=1.5',
  WALK_BACK: 'asset://mp-walk-back.glb?s=1.5',
  RUN: 'asset://mp-jog.glb?s=1.4',
  RUN_LEFT: 'asset://mp-jog-left.glb?s=1.4',
  RUN_RIGHT: 'asset://mp-jog-right.glb?s=1.4',
  RUN_BACK: 'asset://mp-jog-back.glb?s=1.4',
  JUMP: 'asset://emote-jump.glb',
  FALL: 'asset://emote-fall.glb',
  FLY: 'asset://emote-float.glb',
  FLIP: 'asset://emote-flip.glb?s=1.1',
  TALK: 'asset://emote-talk.glb',
}

export const emoteUrls = [
  Emotes.IDLE,
  Emotes.WALK,
  Emotes.WALK_LEFT,
  Emotes.WALK_RIGHT,
  Emotes.WALK_BACK,
  Emotes.RUN,
  Emotes.RUN_LEFT,
  Emotes.RUN_RIGHT,
  Emotes.RUN_BACK,
  Emotes.JUMP,
  Emotes.FALL,
  Emotes.FLY,
  Emotes.FLIP,
  Emotes.TALK,
]
